import React from 'react';
import FeaturedEventCard from './FeaturedEventCard';
import { Carousel } from '@common/bw-ui/ui/carousel';
import { Event } from '@portal/types/nexudus/events';

interface Props {
  events: Event[];
  pastEvents: boolean;
}

const FeaturedEventsCarousel: React.FC<Props> = ({ events, pastEvents }) => {
  if (events.length === 0 || pastEvents) return null;

  return (
    <Carousel
      items={events}
      ariaLabel="Featured Events"
      renderItem={(event) => <FeaturedEventCard featuredEvent={event} />}
    />
  );
};

export default FeaturedEventsCarousel;
